import { createAction, props } from '@ngrx/store';
import { SignalRListener } from 'src/app/models/activity-logs/signalR.model';
import { ActivityLog, MyActivities } from 'src/app/models/activity-logs/activity-logs.model';
import { IActionResult } from 'src/app/services/http-data/apidata.model';

export const addOrUpdateActivity = createAction('[Activity] Add/Update Activity', props<{ listener: SignalRListener, activity: ActivityLog[] }>());

export const loadArchievedActivity = createAction('[Activity] Load Archived Activities');
export const loadArchievedActivitySuccess = createAction('[Activity] Load Archived Activities Success', props<{ activities: MyActivities[] }>());
export const loadArchievedActivityFailed = createAction('[Activity] Load Archived Activities Failed', props<{ error: IActionResult<MyActivities[]> }>());


export const resetArchivedActivity = createAction('[Activity] Reset Archived Activities');